import Column from '@components/Column';
import Indicator from '@components/Indicator';
import styled from '@emotion/styled';
import useScrollIndicator from '@hooks/ui/useScrollIndicator';

import AllButton from './AllButton';
import useRecentOrders from './hooks/useRecentOrders';
import RecentOrder from './RecentOrder';

function RecentOrders() {
    const { onScroll, current } = useScrollIndicator({ totalCount: 6, padding: 20 });
    const orders = useRecentOrders();
    return (
        <Column align='center'>
            <Container onScroll={onScroll} >
                {orders?.map((order) => (
                    <RecentOrder recentOrder={order}
                        key={order.orderId}/>
                ))}
                <AllButton/>
            </Container>
            <Indicator total={6} current={current} />
        </Column>
    );
}

const Container = styled.div`
    column-gap: 16px;
    display: flex;
    overflow-x: auto;
    padding: 10px 20px 22px;
    scroll-padding-left: 20px;
    scroll-snap-type: x mandatory;
    width: 100%;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export default RecentOrders;
